import React from "react";
import PropTypes from "prop-types";

import {classNames} from "../../../utils/Utils";

const ExpandableBox = ({
    id,
    children,
    onEdit,
    className,
    isScrollable,
    ariaLabel,
    ariaLabelledBy,
}) => (
    <li
        className={classNames(
            id ? `document-header-${id}` : null,
            "relative  border-r border-slate-200 bg-slate-50/80 ",
            "shadow-sm shadow-slate-100 transition-shadow",
            className,
        )}
        aria-label={ariaLabel ?? undefined}
        aria-labelledby={ariaLabelledBy ?? undefined}
    >
        <div>
            <div
                className={classNames(
                    "relative  text-sm text-slate-900",
                    "transition-all duration-200",
                )}
            >
                {children}
            </div>
        </div>
    </li>
);

ExpandableBox.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    children: PropTypes.node.isRequired,
    onEdit: PropTypes.func,
    className: PropTypes.string,
    isScrollable: PropTypes.bool,
    ariaLabel: PropTypes.string,
    ariaLabelledBy: PropTypes.string,
};

ExpandableBox.defaultProps = {
    title: null,
    onEdit: null,
    className: "",
    isScrollable: false,
    ariaLabel: null,
    ariaLabelledBy: null,
};

export default ExpandableBox;
